import React from "react";
import CourseTopicMaterials from "../../../../hooks/CourseTopicMaterials";
import {firstFormCourseTopicMaterials} from "../../../../shared/components/FormCourseMaterials/FormCourseMaterials";
import { firstFormTextBooks } from "../../../../shared/components/FormCourseMaterials/FormImages";
import TextBookImages from "../../../../shared/components/TextBookImages/TextBookImages";
import pic1 from '../../../../assets/Images/PageDetails/FirstForm/Picture1.webp'
import pic2 from '../../../../assets/Images/PageDetails/FirstForm/Picture2.webp'


const FirstFormContent = () => {

  return (
    <>
      <CourseTopicMaterials items={firstFormCourseTopicMaterials} leftImage={pic1} rightImage={pic2} />
      <TextBookImages images={firstFormTextBooks} form='First' />
    </>
  )
}

export default FirstFormContent;
